import React, { ReactNode } from 'react';
import { Button } from 'ui-library';
import './EmptyContent.css';

interface IEmptyContentProps {
    data?: any;
    text?: string;
    onClick?: () => void;
    buttonText?: string;
    children?: ReactNode;
}

const EmptyContent = ({
    data = null,
    text = '',
    buttonText = '',
    onClick = () => {},
    children,
} : IEmptyContentProps) => {
    if (data === null || (data && data?.length === 0)) {
        return (
            <>
                {text && <p className="widget__empty">{text}</p>}
                {buttonText && (
                    <div className="widget__button">
                        <Button type="secondary" size="small" onClick={onClick}>{buttonText}</Button>
                    </div>
                )}
            </>
        );
    }

    return children;
};

export default EmptyContent;
